<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <corporation-form />
  </v-container>
</template>

<script>

import CorporationForm from './_Form'

export default {
  name: 'AdminContractorNew',
  components: {
    CorporationForm
  },
  data () {
    return {
      breadcrumbs: [
        { text: '契約者一覧', disabled: false, to: { name: 'AdminContractors' }, exact: true },
        { text: '契約者登録', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}

}
</script>

<style scoped>

</style>
